module.exports = __webpack_public_path__ + "img/pill-box.d6eb32f2.png";